import React from 'react';
import { faThumbsUp, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import i18n from '@s20/i18n';
import CommonContext from '../../Common';
import Slideout from '../Slideout';
import { FormValidated } from './FormElements';
import { SaveButton } from './SaveButton';
import ValidationMessageDisplay from './ValidationMessageDisplay';

export default class SlideForm extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);

        this.state = {
            isValidated: props.isValidated || false,
            isSelfManagedForm: typeof props.children === 'function',
        };

        this.setIsValidated = this.setIsValidated.bind(this);
    }

    /**
     * Use the internally tracked validation state in the absence of one passed in
     */
    setIsValidated = (isValidated) => {
        if (this.props.setIsValidated) {
            this.props.setIsValidated(isValidated);
        } else {
            this.setState({ isValidated });
        }
    };

    /**
     * Use the internally tracked validation state in the absence of one passed in
     */
    getIsValidated = () => this.props.isValidated ?? this.state.isValidated;

    renderHeader = () => {
        const {
            showDelete,
            readOnly,
            hideToolbar,
            removeUnavailable,
            entityId,
            secondarySaveButtonText,
            onSecondarySubmit,
            saveDisabled,
            id,
            saving,
        } = this.props;

        if (!this.props.onSubmit || readOnly || hideToolbar) {
            return null;
        }

        return (
            <div className="d-flex flex-row align-items-center mt-1 mb-2 ml-3">
                <SaveButton
                    type="submit"
                    name={id}
                    disabled={saveDisabled}
                    color="primary"
                    size="sm"
                    label={this.props.saveButtonText ?? i18n.t('common:save')}
                    saving={saving}
                    form={id}
                />

                {Boolean(!removeUnavailable && (entityId || showDelete)) && (
                    <SaveButton
                        icon={faTrashAlt}
                        onClick={this.props.onDelete}
                        label={i18n.t('common:remove')}
                        savingLabel={i18n.t('common:removing')}
                        size="sm"
                        className="ml-2"
                        color="danger"
                        type="button"
                        outlined
                    />
                )}

                {Boolean(secondarySaveButtonText && onSecondarySubmit) && (
                    <SaveButton
                        type="submit"
                        name={`secondary-${id}`}
                        onClick={onSecondarySubmit}
                        disabled={saveDisabled}
                        label={secondarySaveButtonText}
                        icon={faThumbsUp}
                        color="success"
                        outline
                        size="sm"
                        className="ml-2"
                    />
                )}
            </div>
        );
    };

    renderBody = (header, formContext) => {
        const {
            readOnly,
        } = this.props;

        return (
            <>
                {header(this.renderHeader())}

                <ValidationMessageDisplay
                    onClear={this.props.onClearErrors}
                    errors={this.props.errors}
                    message={this.props.error}
                />

                {/* The fieldset only carries `disabled`; a fieldset used as the scroll container loses its scroll position when a section collapses. */}
                <fieldset
                    disabled={readOnly}
                    className="flex-fill d-flex flex-column m-0 p-0 border-0"
                    style={{ minHeight: 0 }}
                >
                    <div className="flex-fill d-flex flex-column p-3">
                        {this.state.isSelfManagedForm ? this.props.children(formContext) : this.props.children}
                    </div>
                </fieldset>
            </>
        );
    };

    render() {
        const {
            id,
            saving = false,
            initialValues = {},
        } = this.props;

        const formProps = {
            id,
            saving,
            initialValues,
            name: id,
            ref: this.props.formRef,
            setIsValidated: this.setIsValidated,
            isValidated: this.getIsValidated(),
            isValid: this.props.isValid,
            className: 'm-0 pb-2 w-100',
            onSubmit: this.props.onSubmit,
        };

        return (
            <Slideout
                isSelfManagedForm={this.state.isSelfManagedForm}
                {...this.props}
            >
                {(renderHeader) => (
                    <>
                        {this.state.isSelfManagedForm ? (
                            <FormValidated
                                {...formProps}
                            >
                                {(ctx) => this.renderBody(renderHeader, ctx)}
                            </FormValidated>
                        ) : (
                            <FormValidated
                                {...formProps}
                            >
                                {this.renderBody(renderHeader)}
                            </FormValidated>
                        )}
                    </>
                )}
            </Slideout>
        );
    }
}
